import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'
import { organisationKeys } from '@core/react-query/features/organisations/organisation'

export const useRemoveCompanyUser = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['removeCompanyUser']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...options,
    ...companyKeys.removeCompanyUser,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(companyKeys.getCompanyDetails._def)
      queryClient.invalidateQueries(companyKeys.getCompanies._def)
      queryClient.invalidateQueries(
        organisationKeys.byId({ organisationId: variables.organisationId })._ctx
          .organisationUsers._def,
      )
      queryClient.invalidateQueries(
        organisationKeys
          .byId({ organisationId: variables.organisationId })
          ._ctx.organisationUser({ userId: variables.userId }),
      )
      options?.onSuccess?.(data, variables, context)
    },
  })
}
